export default class Rule {
	static fromJSON(rawJSON) {
		const rule = new Rule(
			rawJSON._id,
			rawJSON.name,
			rawJSON.type,
			rawJSON.taskType,
			rawJSON.order,
			rawJSON.enabled
		)
			.withLogicalConditions(
				Array.isArray(rawJSON.rule) ? rawJSON.rule : []
			)
			.withOutput(rawJSON.output || {}, rawJSON.type)
			.withAction(rawJSON.action, rawJSON.actionEntity)

		return rule
	}

	static toJSON(rule) {
		let output = {}
		const trigger = {}
		switch (rule.ruleType) {
			case 'AutomationRule': {
				output = {
					automate: rule.output?.automate ?? false,
					metadata: rule.output?.metadata,
				}
				break
			}
			case 'AllocationRule': {
				output =
					rule.output?.type === 'Pool'
						? {
								type: rule.output?.type,
						  }
						: {
								type: rule.output?.type,
								output: rule.output?.output,
						  }
				break
			}
			case 'PriorityRule': {
				output = {
					priority: rule.output?.priority,
				}
				break
			}
			case 'UserExclusionRule': {
				output = {
					userId: rule.output?.userId,
				}
				break
			}
			case 'SystemNotifications': {
				output = {
					type: rule.output?.type,
					output: rule.output?.output,
					message: rule.output?.message,
				}
				trigger.action = rule.action
				trigger.actionEntity = rule.actionEntity
				break
			}
			case 'UserNotifications': {
				output = {
					message: rule.output?.message,
				}
				trigger.action = rule.action
				trigger.actionEntity = rule.actionEntity
				break
			}
			default:
				break
		}

		return {
			[rule.id ? '_id' : undefined]: rule.id,
			name: rule.name,
			ruleType: rule.ruleType,
			taskType: rule.taskType,
			order: rule.order,
			enabled: rule.enabled,
			rule: rule.logicalConditions?.map(
				({ logicalCondition: orLogicalCondition }) => {
					return orLogicalCondition.map((logicalCondition) => ({
						...logicalCondition,
						value: logicalCondition.value,
						option: logicalCondition.option,
						field: logicalCondition.option,
						base: logicalCondition.optionGroup,
						type: logicalCondition.operator,
						operator: logicalCondition.operator,
					}))
				}
			),
			output,
			...trigger,
		}
	}

	constructor(
		id,
		name,
		type,
		taskType,
		order,
		enabled,
		action,
		actionEntity
	) {
		this.id = id
		this.name = name
		this.ruleType = type
		this.taskType = taskType
		this.order = order || 0
		this.enabled = enabled
		this.action = action
		this.actionEntity = actionEntity

		switch (type) {
			case 'AutomationRule': {
				this.output = {
					automate: false,
					metadata: [],
				}
				break
			}
			case 'AllocationRule': {
				this.output = {
					type: 'Pool',
				}
				break
			}
			case 'PriorityRule': {
				this.output = {
					priority: 3,
				}
				break
			}
			case 'UserExclusionRule': {
				break
			}
			default:
				break
		}
	}

	withLogicalConditions(rawConditions = []) {
		this.logicalConditions = rawConditions.map((rawCondition) => {
			return {
				logicalCondition: Array.isArray(rawCondition)
					? rawCondition.map((conditionOperator) => {
							const option =
								conditionOperator.option !== undefined
									? conditionOperator.option
									: conditionOperator.field
							const value =
								option === 'InsuranceProcessNumber' &&
								Array.isArray(conditionOperator.value)
									? conditionOperator.value[0]
									: conditionOperator.value
							return {
								optionGroup:
									conditionOperator.optionGroup !== undefined
										? conditionOperator.optionGroup
										: conditionOperator.base,
								operator:
									conditionOperator.operator ??
									conditionOperator.type,
								option,
								value,
							}
					  })
					: [],
			}
		})
		return this
	}

	withAction(action, actionEntity) {
		this.action = action
		this.actionEntity = actionEntity
		return this
	}

	withOutput(rawOutput, type) {
		let output = {}

		switch (type) {
			case 'AutomationRule': {
				output = {
					automate: rawOutput?.automate ?? false,
					metadata: rawOutput?.metadata,
				}
				break
			}
			case 'AllocationRule': {
				if (rawOutput.type === 'Coordinator') {
					output = {
						type: rawOutput?.type,
						output: rawOutput?.value[0],
					}
				} else {
					output = {
						type: rawOutput?.type,
						output: rawOutput?.value,
					}
				}
				break
			}
			case 'PriorityRule': {
				output = {
					priority: rawOutput?.priority,
				}
				break
			}
			case 'UserExclusionRule': {
				output = {
					userId: rawOutput?.userId,
				}
				break
			}
			case 'SystemNotifications': {
				output = {
					type: rawOutput?.type,
					output: rawOutput?.value,
					message: rawOutput?.message,
				}
				break
			}
			case 'UserNotifications': {
				output = {
					message: rawOutput?.message,
				}
				break
			}
			default:
				break
		}
		this.output = output
		return this
	}
}
